import React, { useEffect, useRef } from "react";

// SASS
import "./Part8.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import virusEnvelope1Img from "../../assets/img/virus-envelope-1.svg";
import virusEnvelope2Img from "../../assets/img/virus-envelope-2.svg";
import virusEnvelope3Img from "../../assets/img/virus-envelope-3.svg";
import envelopeBottomImg from "../../assets/img/envelope-open-bottom.png";
import envelopeTopImg from "../../assets/img/envelope-open-top.png";
import envelopeClosedImg from "../../assets/img/envelope-closed.png";
import stickyNoteImg from "../../assets/img/sticky-note-blank.png";
import dnaImg from "../../assets/img/DNA-strand-blue.svg";

// FUNCTION EXPORT
export default function Part({ step }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    {
      stepNumber: "1",
      height: null,
      description: "fade in virus2, fade in bottom text section1 line1",
    },
    {
      stepNumber: "2",
      height: null,
      description: "fade in virus3, fade in bottom text section1 line2",
    },
    {
      stepNumber: "3",
      height: null,
      description:
        "fade out section1 text, fade out viruses, fade in envelope 1, envelope 2, sticky note",
    },
    {
      stepNumber: "4",
      height: null,
      description:
        "fade out fats, fade out proteins, fade in section2 text span, add classed moved-1/ wait500/ add class moved-2",
    },
    {
      stepNumber: "5",
      height: null,
      description: "fade out envelopebottom, fade in envelope closed",
    },
    { stepNumber: "6", height: null, description: "spacer" },
    { stepNumber: "7", height: null, description: "spacer" },
  ];

  // REFS
  const virus1El = useRef(null);
  const virus2El = useRef(null);
  const virus3El = useRef(null);
  const bottomTextSection1Line1El = useRef(null);
  const bottomTextSection1Line2El = useRef(null);
  const section1Text = useRef(null);
  const section2Text = useRef(null);
  const envelopeBottomEl = useRef(null);
  const envelopeTopEl = useRef(null);
  const envelopeClosedEl = useRef(null);
  const stickyNoteEl = useRef(null);
  const fatsEl = useRef(null);
  const proteinsEl = useRef(null);
  const section2TextSpanEl = useRef(null);
  const topTextEl = useRef(null);

  const virus1ElDesktop = useRef(null);
  const virus2ElDesktop = useRef(null);
  const virus3ElDesktop = useRef(null);
  const bottomTextSection1Line1ElDesktop = useRef(null);
  const bottomTextSection1Line2ElDesktop = useRef(null);
  const section1TextDesktop = useRef(null);
  const section2TextDesktop = useRef(null);
  const envelopeBottomElDesktop = useRef(null);
  const envelopeTopElDesktop = useRef(null);
  const envelopeClosedElDesktop = useRef(null);
  const stickyNoteElDesktop = useRef(null);
  const fatsElDesktop = useRef(null);
  const proteinsElDesktop = useRef(null);
  const section2TextSpanElDesktop = useRef(null);
  const topTextElDesktop = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeInOnEnter(virus2El.current, direction);
            animate.fadeInOnEnter(bottomTextSection1Line1El.current, direction);

            animate.fadeInOnEnter(virus2ElDesktop.current, direction);
            animate.fadeInOnEnter(
              bottomTextSection1Line1ElDesktop.current,
              direction
            );
            break;
          }
          case "2": {
            animate.fadeInOnEnter(virus3El.current, direction);
            animate.fadeInOnEnter(bottomTextSection1Line2El.current, direction);

            animate.fadeInOnEnter(virus3ElDesktop.current, direction);
            animate.fadeInOnEnter(
              bottomTextSection1Line2ElDesktop.current,
              direction
            );
            break;
          }
          case "3": {
            fadeAllViruses(direction);
            animate.fadeOutOnEnter(topTextEl.current, direction);
            animate.fadeOutOnEnter(section1Text.current, direction);
            animate.fadeInOnEnter(section2Text.current, direction);
            animate.fadeInOnEnter(envelopeBottomEl.current, direction);
            animate.fadeInOnEnter(envelopeTopEl.current, direction);
            animate.fadeInOnEnter(stickyNoteEl.current, direction);
            animate.fadeInOnEnter(fatsEl.current, direction);
            animate.fadeInOnEnter(proteinsEl.current, direction);

            animate.fadeOutOnEnter(topTextElDesktop.current, direction);
            animate.fadeOutOnEnter(section1TextDesktop.current, direction);
            animate.addClassOnEnter(
              section1TextDesktop.current,
              "d-none",
              direction
            );
            animate.fadeInOnEnter(section2TextDesktop.current, direction);
            animate.removeClassOnEnter(
              section2TextDesktop.current,
              "d-none",
              direction
            );
            animate.fadeInOnEnter(envelopeBottomElDesktop.current, direction);
            animate.fadeInOnEnter(envelopeTopElDesktop.current, direction);
            animate.fadeInOnEnter(stickyNoteElDesktop.current, direction);
            animate.fadeInOnEnter(fatsElDesktop.current, direction);
            animate.fadeInOnEnter(proteinsElDesktop.current, direction);
            break;
          }
          case "4": {
            animate.fadeOutOnEnter(fatsEl.current, direction);
            animate.fadeOutOnEnter(proteinsEl.current, direction);
            animate.addClassOnEnter(stickyNoteEl.current, "moved-1", direction);
            animate.fadeInOnEnter(section2TextSpanEl.current, direction);
            setTimeout(() => {
              animate.addClassOnEnter(
                stickyNoteEl.current,
                "moved-2",
                direction
              );
            }, 500);

            animate.fadeOutOnEnter(fatsElDesktop.current, direction);
            animate.fadeOutOnEnter(proteinsElDesktop.current, direction);
            animate.addClassOnEnter(
              stickyNoteElDesktop.current,
              "moved-1",
              direction
            );
            animate.fadeInOnEnter(section2TextSpanElDesktop.current, direction);
            setTimeout(() => {
              animate.addClassOnEnter(
                stickyNoteElDesktop.current,
                "moved-2",
                direction
              );
            }, 500);
            break;
          }
          case "5": {
            animate.fadeInOnEnter(envelopeClosedEl.current, direction);
            animate.fadeOutOnEnter(envelopeBottomEl.current, direction);

            animate.fadeInOnEnter(envelopeClosedElDesktop.current, direction);
            animate.fadeOutOnEnter(envelopeBottomElDesktop.current, direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeOutOnExit(virus2El.current, direction);
            animate.fadeOutOnExit(bottomTextSection1Line1El.current, direction);

            animate.fadeOutOnExit(virus2ElDesktop.current, direction);
            animate.fadeOutOnExit(
              bottomTextSection1Line1ElDesktop.current,
              direction
            );
            break;
          }
          case "2": {
            animate.fadeOutOnExit(virus3El.current, direction);
            animate.fadeOutOnExit(bottomTextSection1Line2El.current, direction);

            animate.fadeOutOnExit(virus3ElDesktop.current, direction);
            animate.fadeOutOnExit(
              bottomTextSection1Line2ElDesktop.current,
              direction
            );
            break;
          }
          case "3": {
            unFadeAllViruses(direction);
            animate.fadeInOnExit(topTextEl.current, direction);

            animate.fadeInOnExit(section1Text.current, direction);
            animate.fadeOutOnExit(section2Text.current, direction);
            animate.fadeOutOnExit(envelopeBottomEl.current, direction);
            animate.fadeOutOnExit(envelopeTopEl.current, direction);
            animate.fadeOutOnExit(stickyNoteEl.current, direction);
            animate.fadeOutOnExit(fatsEl.current, direction);
            animate.fadeOutOnExit(proteinsEl.current, direction);

            animate.fadeInOnExit(topTextElDesktop.current, direction);

            animate.fadeInOnExit(section1TextDesktop.current, direction);
            animate.removeClassOnExit(
              section1TextDesktop.current,
              "d-none",
              direction
            );
            animate.fadeOutOnExit(section2TextDesktop.current, direction);
            animate.addClassOnExit(
              section2TextDesktop.current,
              "d-none",
              direction
            );
            animate.fadeOutOnExit(envelopeBottomElDesktop.current, direction);
            animate.fadeOutOnExit(envelopeTopElDesktop.current, direction);
            animate.fadeOutOnExit(stickyNoteElDesktop.current, direction);
            animate.fadeOutOnExit(fatsElDesktop.current, direction);
            animate.fadeOutOnExit(proteinsElDesktop.current, direction);
            break;
          }
          case "4": {
            animate.fadeInOnExit(fatsEl.current, direction);
            animate.fadeInOnExit(proteinsEl.current, direction);
            animate.fadeOutOnExit(section2TextSpanEl.current, direction);
            animate.removeClassOnExit(
              stickyNoteEl.current,
              "moved-2",
              direction
            );
            setTimeout(() => {
              animate.removeClassOnExit(
                stickyNoteEl.current,
                "moved-1",
                direction
              );
            }, 500);

            animate.fadeInOnExit(fatsElDesktop.current, direction);
            animate.fadeInOnExit(proteinsElDesktop.current, direction);
            animate.fadeOutOnExit(section2TextSpanElDesktop.current, direction);
            animate.removeClassOnExit(
              stickyNoteElDesktop.current,
              "moved-2",
              direction
            );
            setTimeout(() => {
              animate.removeClassOnExit(
                stickyNoteElDesktop.current,
                "moved-1",
                direction
              );
            }, 500);
            break;
          }
          case "5": {
            animate.fadeOutOnExit(envelopeClosedEl.current, direction);
            animate.fadeInOnExit(envelopeBottomEl.current, direction);

            animate.fadeOutOnExit(envelopeClosedElDesktop.current, direction);
            animate.fadeInOnExit(envelopeBottomElDesktop.current, direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS
  const fadeAllViruses = (direction) => {
    if (direction === "down") {
      [
        virus1El.current,
        virus2El.current,
        virus3El.current,
        virus1ElDesktop.current,
        virus2ElDesktop.current,
        virus3ElDesktop.current,
      ].forEach((virus) => {
        virus.style.opacity = 0;
      });
    }
  };

  const unFadeAllViruses = (direction) => {
    if (direction === "up") {
      [
        virus1El.current,
        virus2El.current,
        virus3El.current,
        virus1ElDesktop.current,
        virus2ElDesktop.current,
        virus3ElDesktop.current,
      ].forEach((virus) => {
        virus.style.opacity = 1;
      });
    }
  };

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part8">
          <div className="part8__container-mobile">
            <div className="text text-top" ref={topTextEl}>
              Some viruses, like SARS-CoV-2 which causes COVID-19, have an{" "}
              <b>envelope</b>.
            </div>
            <div className="envelope-container">
              <div className="virus virus-1" ref={virus1El}>
                <img src={virusEnvelope1Img} alt="" className="img-fluid" />
              </div>
              <div className="virus virus-2" ref={virus2El}>
                <img src={virusEnvelope2Img} alt="" className="img-fluid" />
              </div>
              <div className="virus virus-3" ref={virus3El}>
                <img src={virusEnvelope3Img} alt="" className="img-fluid" />
              </div>
              <div className="envelope envelope-1" ref={envelopeBottomEl}>
                <img src={envelopeBottomImg} alt="" className="img-fluid" />
              </div>
              <div className="envelope envelope-2" ref={envelopeTopEl}>
                <img src={envelopeTopImg} alt="" className="img-fluid" />
              </div>
              <div className="envelope envelope-3" ref={envelopeClosedEl}>
                <img src={envelopeClosedImg} alt="" className="img-fluid" />
              </div>
              <div className="sticky-note" ref={stickyNoteEl}>
                <img src={stickyNoteImg} alt="" className="img-fluid" />
                <div className="dna">
                  <img src={dnaImg} alt="" className="img-fluid" />
                </div>
              </div>
              <div className="fats" ref={fatsEl}>
                FATS
              </div>
              <div className="proteins" ref={proteinsEl}>
                PROTEINS
              </div>
            </div>
            <div className="text text-bottom">
              <div className="section section-1" ref={section1Text}>
                <div className="line-1" ref={bottomTextSection1Line1El}>
                  The envelope is located outside of the shell and protects the
                  genes inside of it.
                </div>
                <div className="line-2" ref={bottomTextSection1Line2El}>
                  Similar to the shell, the envelope has proteins sticking out
                  of it.
                </div>
              </div>
              <div className="section section-2" ref={section2Text}>
                The virus envelope, similar to a mail envelope, is made up of{" "}
                <b>fats and proteins</b>{" "}
                <span className="state-2" ref={section2TextSpanEl}>
                  to protect the genes inside it, similar to how a mail envelope
                  protects a letter.
                </span>
              </div>
            </div>
          </div>
          <div className="part8__container-desktop">
            <div className="envelope-container">
              <div className="virus virus-1" ref={virus1ElDesktop}>
                <img src={virusEnvelope1Img} alt="" className="img-fluid" />
              </div>
              <div className="virus virus-2" ref={virus2ElDesktop}>
                <img src={virusEnvelope2Img} alt="" className="img-fluid" />
              </div>
              <div className="virus virus-3" ref={virus3ElDesktop}>
                <img src={virusEnvelope3Img} alt="" className="img-fluid" />
              </div>
              <div
                className="envelope envelope-1"
                ref={envelopeBottomElDesktop}
              >
                <img src={envelopeBottomImg} alt="" className="img-fluid" />
              </div>
              <div className="envelope envelope-2" ref={envelopeTopElDesktop}>
                <img src={envelopeTopImg} alt="" className="img-fluid" />
              </div>
              <div
                className="envelope envelope-3"
                ref={envelopeClosedElDesktop}
              >
                <img src={envelopeClosedImg} alt="" className="img-fluid" />
              </div>
              <div className="sticky-note" ref={stickyNoteElDesktop}>
                <img src={stickyNoteImg} alt="" className="img-fluid" />
                <div className="dna">
                  <img src={dnaImg} alt="" className="img-fluid" />
                </div>
              </div>
              <div className="fats" ref={fatsElDesktop}>
                FATS
              </div>
              <div className="proteins" ref={proteinsElDesktop}>
                PROTEINS
              </div>
            </div>
            <div className="text text-bottom">
              <div className="section section-1" ref={section1TextDesktop}>
                <div className="line-0" ref={topTextElDesktop}>
                  Some viruses, like SARS-CoV-2 which causes COVID-19, have an{" "}
                  <b>envelope</b>.
                </div>
                <div className="line-2" ref={bottomTextSection1Line1ElDesktop}>
                  The envelope is located outside of the shell and protects the
                  genes inside of it.
                </div>
                <div className="line-2" ref={bottomTextSection1Line2ElDesktop}>
                  Similar to the shell, the envelope has proteins sticking out
                  of it.
                </div>
              </div>
              <div
                className="section section-2 d-none"
                ref={section2TextDesktop}
              >
                The virus envelope, similar to a mail envelope, is made up of{" "}
                <b>fats and proteins</b>{" "}
                <span className="state-2" ref={section2TextSpanElDesktop}>
                  to protect the genes inside it, similar to how a mail envelope
                  protects a letter.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
